import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import FeatureGrid from './components/FeatureGrid';
import ArticlePreview from './components/ArticlePreview';
import ArticleGrid from './components/ArticleGrid';
import Testimonial from './components/Testimonial';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'ACBuy Spreadsheet',
  'url': 'https://acbuy.my/',
  'description': 'ACBuy Spreadsheet is a data-driven product discovery system that helps users compare prices, track trending items, and make smarter buying decisions.',
  'potentialAction': {
    '@type': 'SearchAction',
    'target': 'https://acbuy.my/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="ACBuy Spreadsheet - Smart Product Discovery & Comparison Tool"
        description="ACBuy Spreadsheet is a data-driven product discovery system that helps you compare prices, track trending items, and make smarter buying decisions. Discover better deals with ACBuy spreadsheet today."
        keywords="acbuy spreadsheet, acbuyspreadsheet, product comparison, shopping spreadsheet, price tracking, product discovery, smart shopping tool"
        canonicalPath="/"
        ogType="website"
      >
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }} />
      </SEOHead>

      <Navbar />

      <main>
        {/* 1. Hero Section */}
        <HeroSection />

        {/* 2. Category Grid Section */}
        <CategoryGrid />

        {/* 3. Full-Screen CTA Section */}
        <CTASection />

        {/* 4. Feature Grid Section */}
        <FeatureGrid />

        {/* 5. SEO Article Preview */}
        <ArticlePreview />

        {/* 6. Article Grid - 9 SEO Articles */}
        <ArticleGrid />

        {/* 7. Testimonial Section */}
        <Testimonial />
      </main>

      <Footer />
    </div>
  );
}